import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  APPOINTMENT_PATH,
  APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_INTRODUCE_PATH,
  APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_QUESTION_SECTION_PATH,
  APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_REVIEW_PATH,
  APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_SUCCESS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const IntroduceSectionPage = lazy(() => import('./pages/IntroduceSectionPage/IntroduceSectionPage'));
const QuestionSectionPage = lazy(() => import('./pages/QuestionSectionPage/QuestionSectionPage'));
const ReviewSectionPage = lazy(() => import('./pages/ReviewSectionPage/ReviewSectionPage'));
const SuccessfulSubmissionPage = lazy(() => import('./pages/SuccessfulSubmissionPage/SuccessfulSubmissionPage'));

export const QUESTIONNAIRE_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <IntroduceSectionPage />,
    displayTitle: () => 'Questionnaire',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_INTRODUCE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <QuestionSectionPage />,
    displayTitle: () => 'Questionnaire',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_QUESTION_SECTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <ReviewSectionPage />,
    displayTitle: () => 'Questionnaire',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_REVIEW_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <SuccessfulSubmissionPage />,
    displayTitle: () => 'Questionnaire',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_PRE_CONSULT_QUESTIONNAIRE_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
];
